import admin from './locales/en/admin.json';
import auth from './locales/en/auth.json';
import common from './locales/en/common.json';
import content from './locales/en/content.json';
import designer from './locales/en/designer.json';
import displays from './locales/en/displays.json';
import groups from './locales/en/groups.json';
import home from './locales/en/home.json';
import layout from './locales/en/layout.json';
import layouts from './locales/en/layouts.json';
import operations from './locales/en/operations.json';
import overview from './locales/en/overview.json';
import playlists from './locales/en/playlists.json';
import reports from './locales/en/reports.json';
import schedule from './locales/en/schedule.json';
import settings from './locales/en/settings.json';
import teams from './locales/en/teams.json';
import videoWalls from './locales/en/videoWalls.json';

/**
 * English ships in the main bundle and is the source of truth: every other
 * language must provide exactly these keys (enforced by locales.test.ts).
 * One namespace per feature area.
 */
export const englishResources = {
  common,
  layout,
  settings,
  auth,
  home,
  overview,
  displays,
  content,
  playlists,
  schedule,
  groups,
  layouts,
  videoWalls,
  designer,
  reports,
  teams,
  admin,
  operations,
};

export type Namespace = keyof typeof englishResources;

export const NAMESPACES = Object.keys(englishResources) as Namespace[];
